<h1>Demo TRANS UNION response scenarios</h1>
<div class="d-flex" style="gap: 10px">
    <button (click)="tuResponse('failed')" type="button" class="btn btn-primary">TU Response Fail</button>
    <button (click)="tuResponse('success')" type="button" class="btn btn-primary">TU Response Pass</button>
</div>